import { render, staticRenderFns } from "./DepartmentDialog.vue?vue&type=template&id=6959b4c4&scoped=true"
import script from "./DepartmentDialog.vue?vue&type=script&lang=js"
export * from "./DepartmentDialog.vue?vue&type=script&lang=js"
import style0 from "./DepartmentDialog.vue?vue&type=style&index=0&id=6959b4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959b4c4",
  null
  
)

export default component.exports